import React from 'react';
import { format } from 'date-fns';

import ExplorerIcon from 'components/FileViewer/ExplorerIcon';
import {
  ExplorerNode, SortKey, pluralize,
} from 'helper/products/fileExplorer';

import './index.scss';

export function resultsLabel({
  entries, isGlobal, hasTerms, folderName,
}: {
  entries: ExplorerNode[];
  isGlobal: boolean;
  hasTerms: boolean;
  folderName: string;
}) {
  const results = pluralize(entries.length, 'resultado', 'resultados');
  if (isGlobal) return `${results} em todas as pastas`;
  if (hasTerms) return `${results} em “${folderName}”`;
  const folders = entries.filter((node) => node.kind === 'folder').length;
  const files = entries.length - folders;
  const parts = [
    folders ? pluralize(folders, 'pasta', 'pastas') : '',
    files ? pluralize(files, 'arquivo', 'arquivos') : '',
  ].filter(Boolean);
  return parts.length ? parts.join(' · ') : 'Nenhum item';
}

export default function ResultsBar({
  label,
  updatedAt,
  isRefreshing,
  canForceRefresh = false,
  onRefresh,
  sortSelect,
}: {
  label: string;
  updatedAt?: number;
  isRefreshing: boolean;
  /** Admin: Atualizar relê o disco no servidor; a barra avisa que a lista fica em cache. */
  canForceRefresh?: boolean;
  onRefresh: () => void;
  /** Mobile: ordenação por select (a tabela do desktop ordena pelo cabeçalho). */
  sortSelect?: { value: SortKey; onChange: (key: SortKey) => void };
}) {
  return (
    <div className="file-explorer-results">
      <span className="file-explorer-results-label" aria-live="polite">{label}</span>
      <div className="file-explorer-results-tools">
        {updatedAt && (
          <span className="file-explorer-updated">{`Atualizado às ${format(updatedAt, 'HH:mm')}`}</span>
        )}
        {canForceRefresh && (
          <span
            className="file-explorer-updated"
            title="O servidor guarda a lista por até 10 min. Atualizar relê o disco (uma vez por minuto)."
          >
            · cache de até 10 min
          </span>
        )}
        <button
          type="button"
          className="file-explorer-refresh"
          aria-label="Atualizar lista"
          title={canForceRefresh ? 'Atualizar (relê o disco agora)' : 'Atualizar lista'}
          onClick={onRefresh}
          disabled={isRefreshing}
        >
          <ExplorerIcon name="refresh" size={15} className={isRefreshing ? 'is-spinning' : ''} />
        </button>
        {sortSelect && (
          <select
            className="file-explorer-sort-select"
            aria-label="Ordenar por"
            value={sortSelect.value}
            onChange={(event) => sortSelect.onChange(event.target.value as SortKey)}
          >
            <option value="name">Nome A–Z</option>
            <option value="date">Mais recentes</option>
            <option value="size">Maior tamanho</option>
          </select>
        )}
      </div>
    </div>
  );
}
